import Player from 'video.js/dist/types/player'
import styled from 'styled-components'
import { useCallback } from 'react'

import VideoPlayer from './VideoPlayer'
import { LightboxItemProps, useLightbox } from './useLightbox'

export default function LightboxItem(item: LightboxItemProps) {
  const { canDisplayOnBrowser } = useLightbox()
  const onLoadImage = useCallback((e: any) => {
    e.target.style.opacity = '1'
  }, [])

  if (!item.viewUrl) {
    return null
  }

  if (item.type === 'image') {
    if (canDisplayOnBrowser(item.contentType)) {
      return (
        <div className='swiper-zoom-container'>
          <img
            alt={item.fileName as string}
            className='swiper-lazy'
            data-src={item.viewUrl}
            onLoad={onLoadImage}
          />
          <div className='swiper-lazy-preloader swiper-lazy-preloader-white'></div>
        </div>
      )
    } else {
      console.warn(
        "File format '{item.contentType}' cannot be displayed in browsers. Please use a supported viewUrl format."
      )
    }
  } else if (item.type === 'video') {
    return (
      <VideoPlayer
        canPlay={!!item.active}
        options={{
          autoPlay: item.autoPlay,
          controls: true,
          fill: true,
          responsive: true,
          sources: [
            { src: item.viewUrl, type: item.contentType ?? 'video/mp4' },
          ],
        }}
        onReady={(player: Player) => {
          if (item.autoPlay) {
            /**
             * Using autoplay attribute is not reliable, using .play() instead
             * https://videojs.com/blog/autoplay-best-practices-with-video-js/
             */
            // wait for player to be ready
            player.ready(() => {
              const promise = player.play()
              if (promise !== undefined) {
                promise
                  .then(() => {
                    // Autoplay started!
                    // console.log('auto play')
                  })
                  .catch((error) => {
                    // Autoplay was prevented.
                    console.log(
                      '==> Lightbox VideoPlayer: autoplay prevented',
                      { error }
                    )
                  })
              }
            })
          }
        }}
        item={item}
        videoJsUseCredentials={true}
      />
    )
  } else if (item.type === 'file' && item.active && item.viewUrl) {
    return (
      <FileViewer
        src={
          'https://docs.google.com/viewer?embedded=true&url=' +
          encodeURIComponent(item.viewUrl)
        }
        title={item.fileName as string}
      />
    )
  }
  return null
}

const FileViewer = styled.iframe`
  margin-top: 65px;
  width: calc(100vw - 150px);
  height: calc(100vh - 80px);
  margin-right: 70px;
  margin-left: 70px;
  border-radius: 8px;
`
